<template>
  <div v-loading="reCaptchaLoading" class="container" @click="callVerify">
    <div class="block">
      <div v-if="status === 0" class="checkbox"></div>
      <div v-else class="verify-success"></div>
      <div class="rc-anchor-center-container">
        <label
          class="rc-anchor-center-item rc-anchor-checkbox-label"
          aria-hidden="true"
          role="presentation"
          id="recaptcha-anchor-label"
          ><span
            aria-live="polite"
            aria-labelledby="recaptcha-accessible-status"
          ></span
          >{{ mxVm$t('recaptcha.tecentText') }}</label
        >
      </div>
    </div>
  </div>
</template>

<script>
const TENCENT_CAPTCHA_TIMEOUT = 5000
const TENCENT_LANG_MAP = {
  cn: 'zh-cn',
  en: 'en',
  ja: 'ja',
}

export default {
  props: {
    value: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      reCaptchaLoading: false,
      status: 0,
    }
  },
  created() {
    // 已经加载过tecent sdk
    if (window && window.__TencentCaptchaExists__) {
      this.init()
    } else {
      this.loadTencentScript()
    }
  },
  mounted() {
    this.verifyPromiseResolve = null
    this.verifyPromiseReject = null
  },
  computed: {
    userLanguage() {
      let current = { code: 'en' }
      this.$i18n.locales.forEach((locale) => {
        if (locale.code == this.$i18n.locale) {
          current = locale
        }
      })
      return TENCENT_LANG_MAP[current.code] || 'en'
    },
  },
  methods: {
    loadTencentScript() {
      this.reCaptchaLoading = true
      const sc = document.createElement('script')
      sc.async = true
      sc.defer = true
      sc.onload = this.onTencentCaptchaLoaded
      sc.onerror = this.onTencentCaptchaError
      sc.src = this.$root.mxEnum.ReCaptcha.tencentScript
      document.head.appendChild(sc)
      this.captchaScript = sc
      this.tencentTimer = setTimeout(() => {
        this.isShowReCaptcha = true
        this.captchaScript.onload = null
        this.captchaScript.onerror = null
        this.captchaScript.remove()
        this.$emit('tencent-error')
        this.reCaptchaLoading = false
      }, TENCENT_CAPTCHA_TIMEOUT)
    },
    removeTencentScript() {
      // eslint-disable-next-line no-unused-expressions
      this.captchaScript?.remove()
    },
    onTencentCaptchaLoaded() {
      clearTimeout(this.tencentTimer)
      this.$emit('tencent-loaded')
      this.reCaptchaLoading = false
      this.init()
    },
    onTencentCaptchaError() {
      clearTimeout(this.tencentTimer)
      this.$emit('tencent-error')
      this.reCaptchaLoading = false
      // 腾讯sdk加载失败，显示google验证码
      this.isShowReCaptcha = true
    },
    init() {
      // eslint-disable-next-line no-undef
      try {
        this.captcha = new TencentCaptcha(
          this.$root.mxEnum.ReCaptcha.tencentKey,
          this.onVerify,
          {
            userLanguage: this.userLanguage,
          }
        )
      } catch (error) {
        console.log('error:', error)
      }
    },
    reset() {
      this.status = 0
    },
    callVerify() {
      this.captcha.show()
    },
    onVerify(res) {
      if (res.errorCode) {
        this.forceFallback()
        return
      }
      if (res.ret === 0) {
        this.status = 1
        this.$emit('verify', {
          captcha_type: 'tencent',
          randstr: res.randstr,
          ticket: res.ticket,
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.container {
  border: 1px solid #d3d3d3;
  cursor: pointer;
  max-width: 260px;
}
.block {
  height: 74px;
  display: flex;
  align-items: center;
  background: #f9f9f9;
  color: #000;
  border-radius: 3px;
}
.checkbox {
  border: 2px solid #c1c1c1;
  height: 24px;
  width: 24px;
  margin: 0 12px 2px 12px;
}
.verify-success {
  background-image: url(data:image/png;base64,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);
  background-repeat: no-repeat;
  border: none;
  height: 30px;
  outline: 0;
  width: 48px;
  background-position: 0 -600px;
}
</style>
